import { render, staticRenderFns } from "./EmShippingTemplate.vue?vue&type=template&id=33f97f42&scoped=true&"
import script from "./EmShippingTemplate.vue?vue&type=script&lang=js&"
export * from "./EmShippingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EmShippingTemplate.vue?vue&type=style&index=0&id=33f97f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f97f42",
  null
  
)

component.options.__file = "EmShippingTemplate.vue"
export default component.exports